import React from 'react';
import PropTypes from 'prop-types';
import { startOf, endOf, diff, earlierDate, laterDate } from 'src/lib/time';
import Timeline from 'src/components/Timeline';
import Icon from 'src/components/Icon';
import {
  isNotStarted,
  isInProgress,
  setStageTime,
  forcastStages
} from 'src/lib/job';

class JobTimeline extends React.Component {
  getScale(stages) {
    const firstStage = stages[0];
    const lastStage = stages[stages.length - 1];
    const scale = {
      start: earlierDate(
        firstStage.start_time,
        firstStage.scheduled_start,
        firstStage.adjusted_scheduled_start
      ),
      end: laterDate(
        lastStage.end_time,
        lastStage.scheduled_end,
        lastStage.adjusted_scheduled_end
      )
    };
    // Round to nearest hours and create total diff
    scale.start = startOf('hour', scale.start).getTime();
    scale.end = endOf('hour', scale.end).getTime();
    scale.total = diff(scale.end, scale.start, 'hours');
    return scale;
  }

  getTasks(job, stages) {
    return stages.map((stage, index) => {
      const task = {
        id: index,
        status: stage.status,
        label: (
          <span>
            <Icon type={stage.type} style={{ marginRight: 7.5 }} />
            {stage.title}
          </span>
        ),
        original: {
          start: stage.scheduled_start,
          end: stage.scheduled_end
        },
        adjusted: {}
      };
      if (isNotStarted(stage)) {
        task.adjusted = { ...task.original };
        if (isInProgress(job)) {
          // if the job is started, estimate
          task.adjusted = {
            start: stage.adjusted_scheduled_start,
            end: stage.adjusted_scheduled_end
          };
        }
        return task;
      } else if (isInProgress(stage)) {
        task.adjusted = {
          start: new Date(stage.start_time).getTime(),
          end: stage.adjusted_scheduled_end
        };
        return task;
      } else {
        task.adjusted = {
          start: new Date(stage.start_time).getTime(),
          end: new Date(stage.end_time).getTime()
        };
        // console.log(task);
        return task;
      }
    });
  }

  handleChange = (task, value, type) => {
    if (this.props.onChange) {
      // const job = updateStageTime(this.props.job, task.id, [start, end]);
      try {
        const job = setStageTime(this.props.job, task.id, value, type);
        this.props.onChange(job);
      } catch (error) {
        console.error(error);
      }
    }
  };

  render() {
    const { job, disabled } = this.props;
    const stages = forcastStages(job);
    const scale = this.getScale(stages);
    const tasks = this.getTasks(job, stages);
    return (
      <Timeline
        disabled={disabled}
        tasks={tasks}
        scale={scale}
        onChange={this.handleChange}
      />
    );
  }
}

JobTimeline.propTypes = {
  job: PropTypes.object.isRequired
};

export default JobTimeline;
